import { combineReducers } from 'redux'
import layout from '../store/layout/reducer'
import notification from './notification/reducer'
import workerLookup from './WorkerLookup/reducer'
import messageCreate from './MessageCreate/reducer'
import responseCreate from './ResponseCreate/reducer'
import homepageCreate from './Homepage/reducer'
import reportJobs from './ReportJobs/reducer'
import reportDetails from './ReportDetails/reducer'
import contactData from './DoNotCall/reducer'
import distroData from './DistributionList/reducer'
import templateData from './MessageTemplate/reducer'
import templateSelectData from './MessageTemplateSelect/reducer'
import auditDetails from './AuditLog/reducer'

const rootReducer = combineReducers({
  layout,
  notification,
  workerLookup,
  messageCreate,
  responseCreate,
  homepageCreate,
  reportJobs,
  reportDetails,
  contactData,
  distroData,
  templateData,
  templateSelectData,
  auditDetails,
})

export default rootReducer
